export const useBackToManageJobs = (slug) => {
  if (slug === null || slug === undefined) {
    return;
  }

  return `/manage-jobs/${slug}`;
};
